<template>
	<footer
		id="footer"
		ref="footer"
	>
		<Row>
			<Container>
				<SignUpCard />
			</Container>
		</Row>
		<Row class="!py-[32px]">
			<Container>
				<section class="footer-primary-block lg:grid lg:grid-cols-3">
					<div
						id="footer-block"
						class="col-span-2 flex flex-col justify-center md:justify-start mx-auto md:!mr-auto md:!ml-0 text-center md:text-left mb-[40px] md:mb-0"
					>
						<NuxtLink
							id="footer-logo"
							width="240"
							height="40"
							to="/"
							class="block min-h-[40px] mx-auto max-w-[240px] mb-[32px]"
						>
							<FooterLogo
								class="w-full h-full min-h-[40px] max-w-[240px]"
								src="/images/sttlogosvg.svg"
								alt="footer-logo"
							/>
						</NuxtLink>

						<small class="text-white">
							Copyright © {{ new Date().getFullYear() }} StocksToTrade.com
						</small>
					</div>
					<div class="footer-main-link-block w-full grid grid-cols-2 gap-[20px]">
						<div class="flex flex-col gap-[20px]">
							<NuxtLink
								class="link"
								to="/top-features/"
							>
								Top Features
							</NuxtLink>

							<NuxtLink
								class="link"
								href="/plans/"
							>
								Pricing
							</NuxtLink>

							<NuxtLink
								class="link"
								to="/blog/"
							>
								Blog
							</NuxtLink>

							<NuxtLink
								class="link"
								to="/about/"
							>
								About
							</NuxtLink>
						</div>
						<div class="flex flex-col gap-[20px]">
							<NuxtLink
								class="link"
								to="/contact/"
							>
								Contact
							</NuxtLink>

							<NuxtLink
								class="link"
								href="https://support.stockstotrade.com/"
							>
								Support
							</NuxtLink>

							<NuxtLink
								class="link"
								to="/system-requirements/"
							>
								System Requirements
							</NuxtLink>

							<NuxtLink
								class="link"
								to="/careers/"
							>
								Careers
							</NuxtLink>

							<NuxtLink
								class="link light-blue-color"
								to="/plans/"
								style="display: none !important"
							>
								Try StocksToTrade Now!
							</NuxtLink>
						</div>
					</div>
				</section>
			</Container>
		</Row>
		<Row class="!py-[32px]">
			<Container>
				<section
					class="footer-secondary-block flex flex-col md:flex-row items-center flex-wrap gap-[32px]"
				>
					<div
						id="footer-social-icons"
						class="flex gap-[28px] lg:gap-[24px] flex-wrap justify-center md:justify-start"
					>
						<NuxtLink
							id="youtube-link"
							href="https://www.youtube.com/@Stockstotrade"
							target="_blank"
							class="social-n-icons"
						>
							<svg
								width="24"
								height="24"
								viewBox="0 0 20 14"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M8 10L13.19 7L8 4V10ZM19.56 2.17C19.69 2.64 19.78 3.27 19.84 4.07C19.91 4.87 19.94 5.56 19.94 6.16L20 7C20 9.19 19.84 10.8 19.56 11.83C19.31 12.73 18.73 13.31 17.83 13.56C17.36 13.69 16.5 13.78 15.18 13.84C13.88 13.91 12.69 13.94 11.59 13.94L10 14C5.81 14 3.2 13.84 2.17 13.56C1.27 13.31 0.69 12.73 0.44 11.83C0.31 11.36 0.22 10.73 0.16 9.93C0.0900001 9.13 0.0599999 8.44 0.0599999 7.84L0 7C0 4.81 0.16 3.2 0.44 2.17C0.69 1.27 1.27 0.69 2.17 0.44C2.64 0.31 3.5 0.22 4.82 0.16C6.12 0.0899998 7.31 0.0599999 8.41 0.0599999L10 0C14.19 0 16.8 0.16 17.83 0.44C18.73 0.69 19.31 1.27 19.56 2.17Z"
									stroke="white"
									fill="none"
								/>
							</svg>
						</NuxtLink>
						<NuxtLink
							id="instagram-link"
							href="https://www.instagram.com/stockstotrade"
							target="_blank"
							class="social-n-icons"
						>
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g id="InstagramLogo">
									<path
										id="Vector"
										d="M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75Z"
										stroke="white"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										id="Vector_2"
										d="M16.125 3.375H7.875C5.38972 3.375 3.375 5.38972 3.375 7.875V16.125C3.375 18.6103 5.38972 20.625 7.875 20.625H16.125C18.6103 20.625 20.625 18.6103 20.625 16.125V7.875C20.625 5.38972 18.6103 3.375 16.125 3.375Z"
										stroke="white"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										id="Vector_3"
										d="M16.875 8.0625C17.3928 8.0625 17.8125 7.64277 17.8125 7.125C17.8125 6.60723 17.3928 6.1875 16.875 6.1875C16.3572 6.1875 15.9375 6.60723 15.9375 7.125C15.9375 7.64277 16.3572 8.0625 16.875 8.0625Z"
										fill="white"
									/>
								</g>
							</svg>
						</NuxtLink>
						<NuxtLink
							id="facebook-link"
							href="https://www.facebook.com/StocksToTrade/"
							target="_blank"
							class="social-n-icons"
						>
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g id="FacebookLogo">
									<path
										id="Vector"
										d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
										stroke="white"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										id="Vector_2"
										d="M15.75 8.25H14.25C13.6533 8.25 13.081 8.48705 12.659 8.90901C12.2371 9.33097 12 9.90326 12 10.5V21"
										stroke="white"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										id="Vector_3"
										d="M9 13.5H15"
										stroke="white"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</g>
							</svg>
						</NuxtLink>
						<NuxtLink
							id="twitter-logo"
							href="https://twitter.com/StocksToTrade"
							target="_blank"
							class="social-n-icons"
						>
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g id="TwitterLogo">
									<g id="layer1">
										<path
											id="path1009"
											d="M2.04876 2.64062L9.77054 12.9654L2 21.3598H3.74884L10.5519 14.0104L16.0486 21.3598H22L13.8438 10.4543L21.0765 2.64062H19.3277L13.0624 9.40935L8.00012 2.64062H2.04876ZM4.62056 3.92882H7.35462L19.4278 20.0714H16.6937L4.62056 3.92882Z"
											fill="white"
										/>
									</g>
								</g>
							</svg>
						</NuxtLink>
						<!-- <NuxtLink
							id="whatsapp-logo"
							href="https://whatsapp.com/channel/0029VaaVr55EQIatcKRurM18"
							target="_blank"
							class="flex items-center justify-center"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 50 50"
								width="48px"
								height="48px"
								fill="white"
								class="opacity-75"
							>
								<path
									d="M 25 2 C 12.309534 2 2 12.309534 2 25 C 2 29.079097 3.1186875 32.88588 4.984375 36.208984 L 2.0371094 46.730469 A 1.0001 1.0001 0 0 0 3.2402344 47.970703 L 14.210938 45.251953 C 17.434629 46.972929 21.092591 48 25 48 C 37.690466 48 48 37.690466 48 25 C 48 12.309534 37.690466 2 25 2 z M 25 4 C 36.609534 4 46 13.390466 46 25 C 46 36.609534 36.609534 46 25 46 C 21.278025 46 17.792121 45.029635 14.761719 43.333984 A 1.0001 1.0001 0 0 0 14.033203 43.236328 L 4.4257812 45.617188 L 7.0019531 36.425781 A 1.0001 1.0001 0 0 0 6.9023438 35.646484 C 5.0606869 32.523592 4 28.890107 4 25 C 4 13.390466 13.390466 4 25 4 z M 16.642578 13 C 16.001539 13 15.086045 13.23849 14.333984 14.048828 C 13.882268 14.535548 12 16.369511 12 19.59375 C 12 22.955271 14.331391 25.855848 14.613281 26.228516 L 14.615234 26.228516 L 14.615234 26.230469 C 14.588494 26.195329 14.973031 26.752191 15.486328 27.419922 C 15.999626 28.087653 16.717405 28.96464 17.619141 29.914062 C 19.422612 31.812909 21.958282 34.007419 25.105469 35.349609 C 26.554789 35.966779 27.698179 36.339417 28.564453 36.611328 C 30.169845 37.115426 31.632073 37.038799 32.730469 36.876953 C 33.55263 36.755876 34.456878 36.361114 35.351562 35.794922 C 36.246248 35.22873 37.12309 34.524722 37.509766 33.455078 C 37.786772 32.688244 37.927591 31.979598 37.978516 31.396484 C 38.003976 31.104927 38.007211 30.847602 37.988281 30.609375 C 37.969311 30.371148 37.989581 30.188664 37.767578 29.824219 C 37.302009 29.059804 36.774753 29.039853 36.224609 28.767578 C 35.918939 28.616297 35.048661 28.191329 34.175781 27.775391 C 33.303883 27.35992 32.54892 26.991953 32.083984 26.826172 C 31.790239 26.720488 31.431556 26.568352 30.914062 26.626953 C 30.396569 26.685553 29.88546 27.058933 29.587891 27.5 C 29.305837 27.918069 28.170387 29.258349 27.824219 29.652344 C 27.819619 29.649544 27.849659 29.663383 27.712891 29.595703 C 27.284761 29.383815 26.761157 29.203652 25.986328 28.794922 C 25.2115 28.386192 24.242255 27.782635 23.181641 26.847656 L 23.181641 26.845703 C 21.603029 25.455949 20.497272 23.711106 20.148438 23.125 C 20.171937 23.09704 20.145643 23.130901 20.195312 23.082031 L 20.197266 23.080078 C 20.553781 22.728924 20.869739 22.309521 21.136719 22.001953 C 21.515257 21.565866 21.68231 21.181437 21.863281 20.822266 C 22.223954 20.10644 22.02313 19.318742 21.814453 18.904297 L 21.814453 18.902344 C 21.828863 18.931014 21.701572 18.650157 21.564453 18.326172 C 21.426943 18.001263 21.251663 17.580039 21.064453 17.130859 C 20.690033 16.232501 20.272027 15.224912 20.023438 14.634766 L 20.023438 14.632812 C 19.730591 13.937684 19.334395 13.436908 18.816406 13.195312 C 18.298417 12.953717 17.840778 13.022402 17.822266 13.021484 L 17.820312 13.021484 C 17.450668 13.004432 17.045038 13 16.642578 13 z M 16.642578 15 C 17.028118 15 17.408214 15.004701 17.726562 15.019531 C 18.054056 15.035851 18.033687 15.037192 17.970703 15.007812 C 17.906713 14.977972 17.993533 14.968282 18.179688 15.410156 C 18.423098 15.98801 18.84317 16.999249 19.21875 17.900391 C 19.40654 18.350961 19.582292 18.773816 19.722656 19.105469 C 19.863021 19.437122 19.939077 19.622295 20.027344 19.798828 L 20.027344 19.800781 L 20.029297 19.802734 C 20.115837 19.973483 20.108185 19.864164 20.078125 19.923828 C 19.867096 20.342656 19.838461 20.445493 19.625 20.691406 C 19.29998 21.065838 18.968453 21.483404 18.792969 21.65625 C 18.639439 21.80707 18.36242 22.042032 18.189453 22.501953 C 18.016221 22.962578 18.097073 23.59457 18.375 24.066406 C 18.745032 24.6946 19.964406 26.679307 21.859375 28.347656 C 23.05276 29.399678 24.164563 30.095933 25.052734 30.564453 C 25.940906 31.032973 26.664301 31.306607 26.826172 31.386719 C 27.210549 31.576953 27.630655 31.72467 28.119141 31.666016 C 28.607627 31.607366 29.02878 31.310979 29.296875 31.007812 L 29.298828 31.005859 C 29.655629 30.601347 30.715848 29.390728 31.224609 28.644531 C 31.246169 28.652131 31.239109 28.646231 31.408203 28.707031 L 31.408203 28.708984 L 31.410156 28.708984 C 31.487356 28.736474 32.454286 29.169267 33.316406 29.580078 C 34.178526 29.990889 35.053561 30.417875 35.337891 30.558594 C 35.748225 30.761674 35.942113 30.893881 35.992188 30.894531 C 35.995572 30.982516 35.998992 31.07786 35.986328 31.222656 C 35.951258 31.624292 35.8439 32.180225 35.628906 32.775391 C 35.523582 33.066746 34.975018 33.667661 34.283203 34.105469 C 33.591388 34.543277 32.749338 34.852514 32.4375 34.898438 C 31.499896 35.036591 30.386672 35.087027 29.164062 34.703125 C 28.316336 34.437036 27.259305 34.092596 25.890625 33.509766 C 23.114812 32.325956 20.755591 30.311513 19.070312 28.537109 C 18.227674 27.649908 17.552562 26.824019 17.072266 26.199219 C 16.592866 25.575584 16.383528 25.251054 16.208984 25.021484 L 16.207031 25.019531 C 15.897202 24.609805 14 21.970851 14 19.59375 C 14 17.077989 15.168497 16.091436 15.800781 15.410156 C 16.132721 15.052495 16.495617 15 16.642578 15 z"
								/>
							</svg>
						</NuxtLink>
						<NuxtLink
							id="telegram-logo"
							href="https://t.me/+oLn4_X4cWWJiZjgx"
							target="_blank"
							class="social-n-icons"
						>
							<svg
								fill="#FFFFFF"
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 50 50"
								width="24px"
								height="24px"
							>
								<path
									d="M 44.376953 5.9863281 C 43.889905 6.0076957 43.415817 6.1432497 42.988281 6.3144531 C 42.565113 6.4845113 40.128883 7.5243408 36.53125 9.0625 C 32.933617 10.600659 28.256963 12.603668 23.621094 14.589844 C 14.349356 18.562196 5.2382813 22.470703 5.2382812 22.470703 L 5.3046875 22.445312 C 5.3046875 22.445312 4.7547875 22.629122 4.1972656 23.017578 C 3.9185047 23.211806 3.6186028 23.462555 3.3730469 23.828125 C 3.127491 24.193695 2.9479735 24.711788 3.015625 25.259766 C 3.2532479 27.184511 5.2480469 27.730469 5.2480469 27.730469 L 5.2558594 27.734375 L 14.158203 30.78125 C 14.385177 31.538434 16.858319 39.792923 17.402344 41.541016 C 17.702797 42.507484 17.984013 43.064995 18.277344 43.445312 C 18.424133 43.635633 18.577962 43.782915 18.748047 43.890625 C 18.815627 43.933415 18.8867 43.965525 18.957031 43.994141 C 18.958531 43.994806 18.959437 43.99348 18.960938 43.994141 C 18.969579 43.997952 18.977708 43.998295 18.986328 44.001953 L 18.962891 43.996094 C 18.979231 44.002694 18.995359 44.013801 19.011719 44.019531 C 19.043456 44.030655 19.062905 44.030268 19.103516 44.039062 C 20.123059 44.395042 20.966797 43.734375 20.966797 43.734375 L 21.001953 43.707031 L 26.470703 38.634766 L 35.345703 45.554688 L 35.457031 45.605469 C 37.010484 46.295216 38.415349 45.910403 39.193359 45.277344 C 39.97137 44.644284 40.277344 43.828125 40.277344 43.828125 L 40.310547 43.742188 L 46.832031 9.7519531 C 46.998903 8.9915162 47.022612 8.334202 46.865234 7.7402344 C 46.707857 7.1462668 46.325492 6.6299361 45.845703 6.34375 C 45.365914 6.0575639 44.864001 5.9649605 44.376953 5.9863281 z M 44.429688 8.0195312 C 44.627491 8.0103707 44.774102 8.032983 44.820312 8.0605469 C 44.866523 8.0881109 44.887272 8.0844829 44.931641 8.2519531 C 44.976011 8.419423 45.000036 8.7721605 44.878906 9.3242188 L 44.875 9.3359375 L 38.390625 43.128906 C 38.375275 43.162926 38.240151 43.475531 37.931641 43.726562 C 37.616914 43.982653 37.266874 44.182554 36.337891 43.792969 L 26.632812 36.224609 L 26.359375 36.009766 L 26.353516 36.015625 L 23.451172 33.837891 L 39.761719 14.648438 A 1.0001 1.0001 0 0 0 38.974609 13 A 1.0001 1.0001 0 0 0 38.445312 13.167969 L 14.84375 28.902344 L 5.9277344 25.849609 C 5.9277344 25.849609 5.0423771 25.356927 5 25.013672 C 4.99765 24.994652 4.9871961 25.011869 5.0332031 24.943359 C 5.0792101 24.874869 5.1948546 24.759225 5.3398438 24.658203 C 5.6298218 24.456159 5.9609375 24.333984 5.9609375 24.333984 L 5.9941406 24.322266 L 6.0273438 24.308594 C 6.0273438 24.308594 15.138894 20.399882 24.410156 16.427734 C 29.045787 14.44166 33.721617 12.440122 37.318359 10.902344 C 40.914175 9.3649615 43.512419 8.2583658 43.732422 8.1699219 C 43.982886 8.0696253 44.231884 8.0286918 44.429688 8.0195312 z M 33.613281 18.792969 L 21.244141 33.345703 L 21.238281 33.351562 A 1.0001 1.0001 0 0 0 21.183594 33.423828 A 1.0001 1.0001 0 0 0 21.128906 33.507812 A 1.0001 1.0001 0 0 0 20.998047 33.892578 A 1.0001 1.0001 0 0 0 20.998047 33.900391 L 19.386719 41.146484 C 19.35993 41.068197 19.341173 41.039555 19.3125 40.947266 L 19.3125 40.945312 C 18.800713 39.30085 16.467362 31.5161 16.144531 30.439453 L 33.613281 18.792969 z M 22.640625 35.730469 L 24.863281 37.398438 L 21.597656 40.425781 L 22.640625 35.730469 z"
								/>
							</svg>
						</NuxtLink> -->
					</div>
					<div
						class="flex flex-wrap justify-center lg:justify-start mx-auto md:ml-auto gap-[16px] md:gap-x-[32px]"
					>
						<NuxtLink
							class="link shade footer"
							to="/disclaimer/"
						>
							Disclaimer
						</NuxtLink>
						<NuxtLink
							class="link shade footer"
							to="/privacy-policy/"
						>
							Privacy Policy
						</NuxtLink>
						<NuxtLink
							class="link shade footer"
							to="/terms-service-use-agreement/"
						>
							Terms of Service
						</NuxtLink>
						<NuxtLink
							class="link shade footer"
							to="/ai-disclosure/"
						>
							AI Use Disclosure
						</NuxtLink>
						<NuxtLink
							class="link shade footer"
							to="/editorial-guidelines/"
						>
							Editorial Guidelines
						</NuxtLink>
						<NuxtLink
							class="link shade footer"
							to="/affiliate-disclosure/"
						>
							Affiliate Disclosure
						</NuxtLink>
						<NuxtLink
							class="link shade footer"
							to="/cookie-policy/"
						>
							Cookie Policy
						</NuxtLink>
						<NuxtLink
							class="link shade footer"
							to="/dmca-takedown-policy/"
						>
							DMCA Takedown Policy
						</NuxtLink>
						<NuxtLink
							class="link shade footer"
							to="/disclosure-of-related-and-partner-entities/"
						>
							Disclosure of Related and Partner Entities
						</NuxtLink>
						<NuxtLink
							class="link shade footer"
							to="https://support.stockstotrade.com/hc/en-us"
							target="_blank"
						>
							Help Center
						</NuxtLink>
					</div>

					<nuxt-link
						href="https://www.traderguard.com/"
						target="_blank"
						class="mx-auto lg:mx-0"
					>
						<img
							src="/images/dmca-protection.png"
							class="h-[40px] objeect-cover"
							alt="DMCA Protection"
						/>
					</nuxt-link>
				</section>
			</Container>
		</Row>
		<Row class="!py-[52px]">
			<Container>
				<div class="flex flex-col text-slate-300">
					<div class="mb-6">
						<p class="text-sm">
							** Results not typical or guaranteed. Past performance is not indicative
							of future returns and financial investing is inherently risky. All
							content is provided subject to the qualifications and limitations set
							forth in our
							<a
								href="https://stockstotrade.com/terms-service-use-agreement/"
								class="text-blue-300 cursor-pointer"
							>
								Terms of Service and Use.
							</a>
						</p>
					</div>

					<div class="flex flex-col md:flex-row md:space-x-8 mb-6">
						<div class="md:w-1/2">
							<p class="text-sm mb-6">
								This is for informational purposes only as StocksToTrade is not
								registered as a securities broker-dealer or an investment adviser. No
								information herein is intended as securities brokerage, investment, tax,
								accounting or legal advice, as an offer or solicitation of an offer to
								sell or buy, or as an endorsement, recommendation or sponsorship of any
								company, security or fund.
							</p>
							<p class="text-sm mb-6">
								StocksToTrade cannot and does not assess, verify or guarantee the
								adequacy, accuracy or completeness of any information, the suitability
								or profitability of any particular investment, or the potential value of
								any investment or informational source.
							</p>
						</div>

						<div class="md:w-1/2 mb-2">
							<p class="text-sm mb-6">
								The reader bears responsibility for his/her own investment research and
								decisions, should seek the advice of a qualified securities professional
								before making any investment, and investigate and fully understand any
								and all risks before investing.
							</p>
							<p class="text-sm">
								StocksToTrade in no way warrants the solvency, financial condition, or
								investment advisability of any of the securities mentioned in
								communications or websites. In addition, StocksToTrade accepts no
								liability whatsoever for any direct or consequential loss arising from
								any use of this information. This information is not intended to be used
								as the sole basis of any investment decision, should it be construed as
								advice designed to meet the investment needs of any particular investor.
								Past performance is not necessarily indicative of future returns.
							</p>
						</div>
					</div>

					<div class="text-sm">
						<p>
							13809 Research Boulevard, Suite 500, Austin, TX 78750, United States
						</p>
					</div>
				</div>
			</Container>
		</Row>
	</footer>
</template>

<script setup>
const footer = ref();
</script>

<style lang="scss" scoped>
@use "~/assets/utils.scss" as *;

.footer-primary-block {
}

.social-n-icons {
	height: 48px;
	width: 48px;
	border: 1px solid white;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 32px;
	img {
		width: 24px;
		height: 24px;
	}
}

#footer {
	background: linear-gradient(
		0deg,
		rgba(9, 13, 24, 1) 0%,
		rgba($purple, 0.6) 50%,
		rgba(9, 13, 24, 1) 100%
	);
	background-color: $slate-900;
	position: relative;
	z-index: 10;
}
</style>
